// src/createEvents.ts
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var createEvents = function () {
  return {
    events: {},
    emit: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var callbacks = this.events[event] || [];
      for (var i = 0, length = callbacks.length; i < length; i++) {
        var _callbacks;
        (_callbacks = callbacks)[i].apply(_callbacks, _to_consumable_array(args));
      }
    },
    on: function on(event, cb) {
      var _this = this;
      if (!this.events[event]) {
        this.events[event] = [cb];
      } else {
        var _this_events_event;
        (_this_events_event = this.events[event]) === null || _this_events_event === void 0 ? void 0 : _this_events_event.push(cb);
      }
      return function () {
        var _this_events_event;
        _this.events[event] = (_this_events_event = _this.events[event]) === null || _this_events_event === void 0 ? void 0 : _this_events_event.filter(function (i) {
          return cb !== i;
        });
      };
    }
  };
};
var createResolver = function (param) {
  var emitter = param.emitter,
    evaluate = param.evaluate,
    eventId = param.eventId,
    _param_failHandler = param.failHandler,
    failHandler = _param_failHandler === void 0 ? false : _param_failHandler,
    methodName = param.methodName,
    onFallback = param.onFallback;
  return new Promise(function (resolve, reject) {
    var unbind = emitter.on("".concat(methodName, "-").concat(eventId), function (data, throwOccurred) {
      unbind();
      if (throwOccurred) {
        if (_instanceof(failHandler, Error)) {
          onFallback === null || onFallback === void 0 ? void 0 : onFallback();
          reject(failHandler);
        } else {
          resolve(void 0);
        }
      } else {
        resolve(data);
      }
    });
    evaluate();
  });
};
// src/createRandomId.tsx
var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
var ID_LENGTH = 21;
var createRandomId = function () {
  var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ID_LENGTH;
  var randomValues = Array.from({
    length: size
  }, function () {
    return TABLE[Math.floor(Math.random() * TABLE.length)];
  });
  return randomValues.join("");
};
// src/equals.ts
var equals = function (a, b) {
  if (a === b) {
    return true;
  }
  if (a && b && (typeof a === "undefined" ? "undefined" : _type_of(a)) === "object" && (typeof b === "undefined" ? "undefined" : _type_of(b)) === "object") {
    var arrA = Array.isArray(a);
    var arrB = Array.isArray(b);
    var i;
    var length;
    var key;
    if (arrA && arrB) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (i = length; i-- !== 0;) {
        if (!equals(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    if (arrA !== arrB) {
      return false;
    }
    var keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equals(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
};
// src/noop.ts
var noop = function () {};
// src/removeUndefinedKeys.tsx
var removeUndefinedKeys = function (obj) {
  var _iteratorNormalCompletion = true,
    _didIteratorError = false,
    _iteratorError = undefined;
  try {
    for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      if (obj[key] === void 0) {
        delete obj[key];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return obj;
};
// src/timeout.ts
var timeout = function (ms) {
  var throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      if (throwOnError) {
        reject(new Error("Timeout"));
      } else {
        resolve(void 0);
      }
    }, ms);
  });
};
export { createEvents, createRandomId, createResolver, equals, noop, removeUndefinedKeys, timeout };